export default "/images/vendor/flag-icon-css/flags/4x3/sh.svg?cc6a7545541b76339e38838cf34a4ee5";